import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { filter, first, map } from "rxjs/operators";
import { EntityId, ICirculationInit } from "src/app/interfaces";
import { NavigationService } from "src/app/services";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { selectCirculationIsLoading } from "../../state";

@Component({
    selector: "circ-list-shell",
    templateUrl: "./list-shell.component.html",
    styleUrls: ["./list-shell.component.scss"],
    standalone: false
})
export class ListShellComponent {
  public filterActions = [
    { id: "InCreation", displayName: "status_InCreation" },
    { id: "InProgress", displayName: "status_InProgress" },
    { id: "Canceled", displayName: "status_Canceled" },
    { id: "Finished", displayName: "status_Finished" },
    { id: "Errored", displayName: "status_Errored" }
  ];
  public isLoading$: Observable<boolean>;
  public isLoading: boolean;
  public circulations$: Observable<ICirculationInit[]>;
  public selectedFilterId = "InProgress";
  private selectedFilterSubject = new BehaviorSubject(this.selectedFilterId);

  constructor(
    private store: Store,
    private navigate: NavigationService,
    private circulationFacade: CirculationFacade
  ) {
    //NTH - Remove / Change loading logic
    this.isLoading$ = this.store.select(selectCirculationIsLoading);

    this.circulations$ = combineLatest([
      this.circulationFacade.getCirculationProps(),
      this.selectedFilterSubject
    ]).pipe(
      map(([circulation, status]) =>
        circulation.filter((circ) => circ.status === status)
      )
    );
  }

  public onFilterClick(filterId: string): void {
    this.selectedFilterSubject.next(filterId);
    this.selectedFilterId = filterId;
  }

  public onCellClick(circulationId: string): void {
    this.navigate.toCirculation(circulationId);
  }
  public isReady(): boolean {
    return !this.isLoading;
  }
  public onCopyClick(circulationId: EntityId): void {
    this.isLoading = true;
    this.circulationFacade
      .copyCirculation(circulationId)
      .pipe(
        filter((x) => !!x),
        first()
      )
      .subscribe({
        next: (id) => this.navigate.toCirculation(id.id),
        error: (err) =>
          this.navigate.toError(
            "Error in Circulation copy. - " + JSON.stringify(err)
          )
      });
  }
}
